import NavTabs from '../components/NavTabs';

function Company() {

  return (
    <div className="text-gray-800">
      {/* Hero 배경 섹션 */}
      <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white">제이디윈태크</h1>
          <p className="mt-4 text-white text-lg md:text-xl">
            JDWinTech은 스마트 공조와 배연 시스템의 선도 기업입니다.
          </p>
        </div>

        {/* 하단 탭 메뉴 */}
        <NavTabs />
      </section>

      {/* 회사정보 테이블 섹션 */}
      <section className="pt-16 px-6 md:px-20 max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold mb-8 text-center">회사 소개</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-left border border-gray-300">
            <tbody className="text-sm md:text-base">
              <tr className="border-b border-gray-200">
                <th className="p-3 bg-gray-100 w-40">상호</th>
                <td className="p-3">제이디윈태크</td>
              </tr>
              <tr className="border-b border-gray-200">
                <th className="p-3 bg-gray-100">대표이사</th>
                <td className="p-3">박민경</td>
              </tr>
              <tr className="border-b border-gray-200">
                <th className="p-3 bg-gray-100">업종</th>
                <td className="p-3">건설 및 제조업</td>
              </tr>
              <tr className="border-b border-gray-200">
                <th className="p-3 bg-gray-100">소재지</th>
                <td className="p-3">인천광역시 동구 송림동 294번지 산업유통센터 16동</td>
              </tr>
              <tr className="border-b border-gray-200">
                <th className="p-3 bg-gray-100">대표번호</th>
                <td className="p-3">031-908-4833</td>
              </tr>
              <tr className="border-b border-gray-200">
                <th className="p-3 bg-gray-100">팩스번호</th>
                <td className="p-3">031-908-4817</td>
              </tr>
              <tr className="border-b border-gray-200">
                <th className="p-3 bg-gray-100">영업종목</th>
                <td className="p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>창호의 배연설비 제조 및 전문제조 시공 업체</li>
                    <li>배연창 및 환기창(고창) 제조 판매업</li>
                    <li>자동문·일반형, 특수형, 산업용 제조 판매업</li>
                  </ul>
                </td>
              </tr>
              <tr className="border-b border-gray-200">
                <th className="p-3 bg-gray-100">면허사항</th>
                <td className="p-3">창호 공사업 (서울 97-08-1)</td>
              </tr>
              <tr>
                <th className="p-3 bg-gray-100">품질관리</th>
                <td className="p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>"Q" MARK 품질보증 지정업체: Z18Q-2008-01 (한국전기전자 시험연구소)</li>
                    <li>배연창개폐기 발명특허 (제132797호) : 특허청</li>
                    <li>배연창개폐기 의장특허 (제158669호) : 특허청</li>
                    <li>ISO 9001:2015 인증</li>
                    <li>기술혁신형 중소기업 (INNO-BIZ) 확인서</li>
                    <li>벤처기업 확인서</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* 구글 지도 섹션 */}
      <section className="mt-16 max-w-6xl mx-auto px-6">
        <h2 className="text-2xl font-bold mb-4 text-center">오시는 길</h2>
        <div className="w-full h-[400px] rounded-lg overflow-hidden shadow-md">
          <iframe
            title="JDWinTech Location"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d1582.9536635706056!2d126.65321288883233!3d37.48651322133996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1z7J247LKc6rSR7Jet7IucIOuPmeq1rCDshqHrprzrj5kgMjk067KI7KeAIOyCsOyXheycoO2GteyEvO2EsCAxNuuPmQ!5e0!3m2!1sko!2skr!4v1767464209849!5m2!1sko!2skr"
          ></iframe>
        </div>
      </section>
    </div>
  );
}

export default Company;
